import {
	AcademicCapIcon as AcademicCapIconOutline,
	AdjustmentsIcon as AdjustmentsIconOutline,
	AnnotationIcon as AnnotationIconOutline,
	ArchiveIcon as ArchiveIconOutline,
	ArrowCircleDownIcon as ArrowCircleDownIconOutline,
	ArrowCircleLeftIcon as ArrowCircleLeftIconOutline,
	ArrowCircleRightIcon as ArrowCircleRightIconOutline,
	ArrowCircleUpIcon as ArrowCircleUpIconOutline,
	ArrowDownIcon as ArrowDownIconOutline,
	ArrowLeftIcon as ArrowLeftIconOutline,
	ArrowNarrowDownIcon as ArrowNarrowDownIconOutline,
	ArrowNarrowLeftIcon as ArrowNarrowLeftIconOutline,
	ArrowNarrowRightIcon as ArrowNarrowRightIconOutline,
	ArrowNarrowUpIcon as ArrowNarrowUpIconOutline,
	ArrowRightIcon as ArrowRightIconOutline,
	ArrowsExpandIcon as ArrowsExpandIconOutline,
	ArrowSmDownIcon as ArrowSmDownIconOutline,
	ArrowSmLeftIcon as ArrowSmLeftIconOutline,
	ArrowSmRightIcon as ArrowSmRightIconOutline,
	ArrowSmUpIcon as ArrowSmUpIconOutline,
	ArrowUpIcon as ArrowUpIconOutline,
	AtSymbolIcon as AtSymbolIconOutline,
	BackspaceIcon as BackspaceIconOutline,
	BadgeCheckIcon as BadgeCheckIconOutline,
	BanIcon as BanIconOutline,
	BeakerIcon as BeakerIconOutline,
	BellIcon as BellIconOutline,
	BookmarkAltIcon as BookmarkAltIconOutline,
	BookmarkIcon as BookmarkIconOutline,
	BookOpenIcon as BookOpenIconOutline,
	BriefcaseIcon as BriefcaseIconOutline,
	CakeIcon as CakeIconOutline,
	CalculatorIcon as CalculatorIconOutline,
	CalendarIcon as CalendarIconOutline,
	CameraIcon as CameraIconOutline,
	CashIcon as CashIconOutline,
	ChartBarIcon as ChartBarIconOutline,
	ChartPieIcon as ChartPieIconOutline,
	ChartSquareBarIcon as ChartSquareBarIconOutline,
	ChatAlt2Icon as ChatAlt2IconOutline,
	ChatAltIcon as ChatAltIconOutline,
	ChatIcon as ChatIconOutline,
	CheckCircleIcon as CheckCircleIconOutline,
	CheckIcon as CheckIconOutline,
	ChevronDoubleDownIcon as ChevronDoubleDownIconOutline,
	ChevronDoubleLeftIcon as ChevronDoubleLeftIconOutline,
	ChevronDoubleRightIcon as ChevronDoubleRightIconOutline,
	ChevronDoubleUpIcon as ChevronDoubleUpIconOutline,
	ChevronDownIcon as ChevronDownIconOutline,
	ChevronLeftIcon as ChevronLeftIconOutline,
	ChevronRightIcon as ChevronRightIconOutline,
	ChevronUpIcon as ChevronUpIconOutline,
	ChipIcon as ChipIconOutline,
	ClipboardCheckIcon as ClipboardCheckIconOutline,
	ClipboardCopyIcon as ClipboardCopyIconOutline,
	ClipboardIcon as ClipboardIconOutline,
	ClipboardListIcon as ClipboardListIconOutline,
	ClockIcon as ClockIconOutline,
	CloudDownloadIcon as CloudDownloadIconOutline,
	CloudIcon as CloudIconOutline,
	CloudUploadIcon as CloudUploadIconOutline,
	CodeIcon as CodeIconOutline,
	CogIcon as CogIconOutline,
	CollectionIcon as CollectionIconOutline,
	ColorSwatchIcon as ColorSwatchIconOutline,
	CreditCardIcon as CreditCardIconOutline,
	CubeIcon as CubeIconOutline,
	CubeTransparentIcon as CubeTransparentIconOutline,
	CurrencyBangladeshiIcon as CurrencyBangladeshiIconOutline,
	CurrencyDollarIcon as CurrencyDollarIconOutline,
	CurrencyEuroIcon as CurrencyEuroIconOutline,
	CurrencyPoundIcon as CurrencyPoundIconOutline,
	CurrencyRupeeIcon as CurrencyRupeeIconOutline,
	CurrencyYenIcon as CurrencyYenIconOutline,
	CursorClickIcon as CursorClickIconOutline,
	DatabaseIcon as DatabaseIconOutline,
	DesktopComputerIcon as DesktopComputerIconOutline,
	DeviceMobileIcon as DeviceMobileIconOutline,
	DeviceTabletIcon as DeviceTabletIconOutline,
	DocumentAddIcon as DocumentAddIconOutline,
	DocumentDownloadIcon as DocumentDownloadIconOutline,
	DocumentDuplicateIcon as DocumentDuplicateIconOutline,
	DocumentIcon as DocumentIconOutline,
	DocumentRemoveIcon as DocumentRemoveIconOutline,
	DocumentReportIcon as DocumentReportIconOutline,
	DocumentSearchIcon as DocumentSearchIconOutline,
	DocumentTextIcon as DocumentTextIconOutline,
	DotsCircleHorizontalIcon as DotsCircleHorizontalIconOutline,
	DotsHorizontalIcon as DotsHorizontalIconOutline,
	DotsVerticalIcon as DotsVerticalIconOutline,
	DownloadIcon as DownloadIconOutline,
	DuplicateIcon as DuplicateIconOutline,
	EmojiHappyIcon as EmojiHappyIconOutline,
	EmojiSadIcon as EmojiSadIconOutline,
	ExclamationCircleIcon as ExclamationCircleIconOutline,
	ExclamationIcon as ExclamationIconOutline,
	ExternalLinkIcon as ExternalLinkIconOutline,
	EyeIcon as EyeIconOutline,
	EyeOffIcon as EyeOffIconOutline,
	FastForwardIcon as FastForwardIconOutline,
	FilmIcon as FilmIconOutline,
	FilterIcon as FilterIconOutline,
	FingerPrintIcon as FingerPrintIconOutline,
	FireIcon as FireIconOutline,
	FlagIcon as FlagIconOutline,
	FolderAddIcon as FolderAddIconOutline,
	FolderDownloadIcon as FolderDownloadIconOutline,
	FolderIcon as FolderIconOutline,
	FolderOpenIcon as FolderOpenIconOutline,
	FolderRemoveIcon as FolderRemoveIconOutline,
	GiftIcon as GiftIconOutline,
	GlobeAltIcon as GlobeAltIconOutline,
	GlobeIcon as GlobeIconOutline,
	HandIcon as HandIconOutline,
	HashtagIcon as HashtagIconOutline,
	HeartIcon as HeartIconOutline,
	HomeIcon as HomeIconOutline,
	IdentificationIcon as IdentificationIconOutline,
	InboxIcon as InboxIconOutline,
	InboxInIcon as InboxInIconOutline,
	InformationCircleIcon as InformationCircleIconOutline,
	KeyIcon as KeyIconOutline,
	LibraryIcon as LibraryIconOutline,
	LightBulbIcon as LightBulbIconOutline,
	LightningBoltIcon as LightningBoltIconOutline,
	LinkIcon as LinkIconOutline,
	LocationMarkerIcon as LocationMarkerIconOutline,
	LockClosedIcon as LockClosedIconOutline,
	LockOpenIcon as LockOpenIconOutline,
	LoginIcon as LoginIconOutline,
	LogoutIcon as LogoutIconOutline,
	MailIcon as MailIconOutline,
	MailOpenIcon as MailOpenIconOutline,
	MapIcon as MapIconOutline,
	MenuAlt1Icon as MenuAlt1IconOutline,
	MenuAlt2Icon as MenuAlt2IconOutline,
	MenuAlt3Icon as MenuAlt3IconOutline,
	MenuAlt4Icon as MenuAlt4IconOutline,
	MenuIcon as MenuIconOutline,
	MicrophoneIcon as MicrophoneIconOutline,
	MinusCircleIcon as MinusCircleIconOutline,
	MinusIcon as MinusIconOutline,
	MinusSmIcon as MinusSmIconOutline,
	MoonIcon as MoonIconOutline,
	MusicNoteIcon as MusicNoteIconOutline,
	NewspaperIcon as NewspaperIconOutline,
	OfficeBuildingIcon as OfficeBuildingIconOutline,
	PaperAirplaneIcon as PaperAirplaneIconOutline,
	PaperClipIcon as PaperClipIconOutline,
	PauseIcon as PauseIconOutline,
	PencilAltIcon as PencilAltIconOutline,
	PencilIcon as PencilIconOutline,
	PhoneIcon as PhoneIconOutline,
	PhoneIncomingIcon as PhoneIncomingIconOutline,
	PhoneMissedCallIcon as PhoneMissedCallIconOutline,
	PhoneOutgoingIcon as PhoneOutgoingIconOutline,
	PhotographIcon as PhotographIconOutline,
	PlayIcon as PlayIconOutline,
	PlusCircleIcon as PlusCircleIconOutline,
	PlusIcon as PlusIconOutline,
	PlusSmIcon as PlusSmIconOutline,
	PresentationChartBarIcon as PresentationChartBarIconOutline,
	PresentationChartLineIcon as PresentationChartLineIconOutline,
	PrinterIcon as PrinterIconOutline,
	PuzzleIcon as PuzzleIconOutline,
	QrcodeIcon as QrcodeIconOutline,
	QuestionMarkCircleIcon as QuestionMarkCircleIconOutline,
	ReceiptRefundIcon as ReceiptRefundIconOutline,
	ReceiptTaxIcon as ReceiptTaxIconOutline,
	RefreshIcon as RefreshIconOutline,
	ReplyIcon as ReplyIconOutline,
	RewindIcon as RewindIconOutline,
	RssIcon as RssIconOutline,
	SaveAsIcon as SaveAsIconOutline,
	SaveIcon as SaveIconOutline,
	ScaleIcon as ScaleIconOutline,
	ScissorsIcon as ScissorsIconOutline,
	SearchCircleIcon as SearchCircleIconOutline,
	SearchIcon as SearchIconOutline,
	SelectorIcon as SelectorIconOutline,
	ServerIcon as ServerIconOutline,
	ShareIcon as ShareIconOutline,
	ShieldCheckIcon as ShieldCheckIconOutline,
	ShieldExclamationIcon as ShieldExclamationIconOutline,
	ShoppingBagIcon as ShoppingBagIconOutline,
	ShoppingCartIcon as ShoppingCartIconOutline,
	SortAscendingIcon as SortAscendingIconOutline,
	SortDescendingIcon as SortDescendingIconOutline,
	SparklesIcon as SparklesIconOutline,
	SpeakerphoneIcon as SpeakerphoneIconOutline,
	StarIcon as StarIconOutline,
	StatusOfflineIcon as StatusOfflineIconOutline,
	StatusOnlineIcon as StatusOnlineIconOutline,
	StopIcon as StopIconOutline,
	SunIcon as SunIconOutline,
	SupportIcon as SupportIconOutline,
	SwitchHorizontalIcon as SwitchHorizontalIconOutline,
	SwitchVerticalIcon as SwitchVerticalIconOutline,
	TableIcon as TableIconOutline,
	TagIcon as TagIconOutline,
	TemplateIcon as TemplateIconOutline,
	TerminalIcon as TerminalIconOutline,
	ThumbDownIcon as ThumbDownIconOutline,
	ThumbUpIcon as ThumbUpIconOutline,
	TicketIcon as TicketIconOutline,
	TranslateIcon as TranslateIconOutline,
	TrashIcon as TrashIconOutline,
	TrendingDownIcon as TrendingDownIconOutline,
	TrendingUpIcon as TrendingUpIconOutline,
	TruckIcon as TruckIconOutline,
	UploadIcon as UploadIconOutline,
	UserAddIcon as UserAddIconOutline,
	UserCircleIcon as UserCircleIconOutline,
	UserGroupIcon as UserGroupIconOutline,
	UserIcon as UserIconOutline,
	UserRemoveIcon as UserRemoveIconOutline,
	UsersIcon as UsersIconOutline,
	VariableIcon as VariableIconOutline,
	VideoCameraIcon as VideoCameraIconOutline,
	ViewBoardsIcon as ViewBoardsIconOutline,
	ViewGridAddIcon as ViewGridAddIconOutline,
	ViewGridIcon as ViewGridIconOutline,
	ViewListIcon as ViewListIconOutline,
	VolumeOffIcon as VolumeOffIconOutline,
	VolumeUpIcon as VolumeUpIconOutline,
	WifiIcon as WifiIconOutline,
	XCircleIcon as XCircleIconOutline,
	XIcon as XIconOutline,
	ZoomInIcon as ZoomInIconOutline,
	ZoomOutIcon as ZoomOutIconOutline,
} from '@heroicons/react/outline';
import {
	AcademicCapIcon as AcademicCapIconSolid,
	AdjustmentsIcon as AdjustmentsIconSolid,
	AnnotationIcon as AnnotationIconSolid,
	ArchiveIcon as ArchiveIconSolid,
	ArrowCircleDownIcon as ArrowCircleDownIconSolid,
	ArrowCircleLeftIcon as ArrowCircleLeftIconSolid,
	ArrowCircleRightIcon as ArrowCircleRightIconSolid,
	ArrowCircleUpIcon as ArrowCircleUpIconSolid,
	ArrowDownIcon as ArrowDownIconSolid,
	ArrowLeftIcon as ArrowLeftIconSolid,
	ArrowNarrowDownIcon as ArrowNarrowDownIconSolid,
	ArrowNarrowLeftIcon as ArrowNarrowLeftIconSolid,
	ArrowNarrowRightIcon as ArrowNarrowRightIconSolid,
	ArrowNarrowUpIcon as ArrowNarrowUpIconSolid,
	ArrowRightIcon as ArrowRightIconSolid,
	ArrowsExpandIcon as ArrowsExpandIconSolid,
	ArrowSmDownIcon as ArrowSmDownIconSolid,
	ArrowSmLeftIcon as ArrowSmLeftIconSolid,
	ArrowSmRightIcon as ArrowSmRightIconSolid,
	ArrowSmUpIcon as ArrowSmUpIconSolid,
	ArrowUpIcon as ArrowUpIconSolid,
	AtSymbolIcon as AtSymbolIconSolid,
	BackspaceIcon as BackspaceIconSolid,
	BadgeCheckIcon as BadgeCheckIconSolid,
	BanIcon as BanIconSolid,
	BeakerIcon as BeakerIconSolid,
	BellIcon as BellIconSolid,
	BookmarkAltIcon as BookmarkAltIconSolid,
	BookmarkIcon as BookmarkIconSolid,
	BookOpenIcon as BookOpenIconSolid,
	BriefcaseIcon as BriefcaseIconSolid,
	CakeIcon as CakeIconSolid,
	CalculatorIcon as CalculatorIconSolid,
	CalendarIcon as CalendarIconSolid,
	CameraIcon as CameraIconSolid,
	CashIcon as CashIconSolid,
	ChartBarIcon as ChartBarIconSolid,
	ChartPieIcon as ChartPieIconSolid,
	ChartSquareBarIcon as ChartSquareBarIconSolid,
	ChatAlt2Icon as ChatAlt2IconSolid,
	ChatAltIcon as ChatAltIconSolid,
	ChatIcon as ChatIconSolid,
	CheckCircleIcon as CheckCircleIconSolid,
	CheckIcon as CheckIconSolid,
	ChevronDoubleDownIcon as ChevronDoubleDownIconSolid,
	ChevronDoubleLeftIcon as ChevronDoubleLeftIconSolid,
	ChevronDoubleRightIcon as ChevronDoubleRightIconSolid,
	ChevronDoubleUpIcon as ChevronDoubleUpIconSolid,
	ChevronDownIcon as ChevronDownIconSolid,
	ChevronLeftIcon as ChevronLeftIconSolid,
	ChevronRightIcon as ChevronRightIconSolid,
	ChevronUpIcon as ChevronUpIconSolid,
	ChipIcon as ChipIconSolid,
	ClipboardCheckIcon as ClipboardCheckIconSolid,
	ClipboardCopyIcon as ClipboardCopyIconSolid,
	ClipboardIcon as ClipboardIconSolid,
	ClipboardListIcon as ClipboardListIconSolid,
	ClockIcon as ClockIconSolid,
	CloudDownloadIcon as CloudDownloadIconSolid,
	CloudIcon as CloudIconSolid,
	CloudUploadIcon as CloudUploadIconSolid,
	CodeIcon as CodeIconSolid,
	CogIcon as CogIconSolid,
	CollectionIcon as CollectionIconSolid,
	ColorSwatchIcon as ColorSwatchIconSolid,
	CreditCardIcon as CreditCardIconSolid,
	CubeIcon as CubeIconSolid,
	CubeTransparentIcon as CubeTransparentIconSolid,
	CurrencyBangladeshiIcon as CurrencyBangladeshiIconSolid,
	CurrencyDollarIcon as CurrencyDollarIconSolid,
	CurrencyEuroIcon as CurrencyEuroIconSolid,
	CurrencyPoundIcon as CurrencyPoundIconSolid,
	CurrencyRupeeIcon as CurrencyRupeeIconSolid,
	CurrencyYenIcon as CurrencyYenIconSolid,
	CursorClickIcon as CursorClickIconSolid,
	DatabaseIcon as DatabaseIconSolid,
	DesktopComputerIcon as DesktopComputerIconSolid,
	DeviceMobileIcon as DeviceMobileIconSolid,
	DeviceTabletIcon as DeviceTabletIconSolid,
	DocumentAddIcon as DocumentAddIconSolid,
	DocumentDownloadIcon as DocumentDownloadIconSolid,
	DocumentDuplicateIcon as DocumentDuplicateIconSolid,
	DocumentIcon as DocumentIconSolid,
	DocumentRemoveIcon as DocumentRemoveIconSolid,
	DocumentReportIcon as DocumentReportIconSolid,
	DocumentSearchIcon as DocumentSearchIconSolid,
	DocumentTextIcon as DocumentTextIconSolid,
	DotsCircleHorizontalIcon as DotsCircleHorizontalIconSolid,
	DotsHorizontalIcon as DotsHorizontalIconSolid,
	DotsVerticalIcon as DotsVerticalIconSolid,
	DownloadIcon as DownloadIconSolid,
	DuplicateIcon as DuplicateIconSolid,
	EmojiHappyIcon as EmojiHappyIconSolid,
	EmojiSadIcon as EmojiSadIconSolid,
	ExclamationCircleIcon as ExclamationCircleIconSolid,
	ExclamationIcon as ExclamationIconSolid,
	ExternalLinkIcon as ExternalLinkIconSolid,
	EyeIcon as EyeIconSolid,
	EyeOffIcon as EyeOffIconSolid,
	FastForwardIcon as FastForwardIconSolid,
	FilmIcon as FilmIconSolid,
	FilterIcon as FilterIconSolid,
	FingerPrintIcon as FingerPrintIconSolid,
	FireIcon as FireIconSolid,
	FlagIcon as FlagIconSolid,
	FolderAddIcon as FolderAddIconSolid,
	FolderDownloadIcon as FolderDownloadIconSolid,
	FolderIcon as FolderIconSolid,
	FolderOpenIcon as FolderOpenIconSolid,
	FolderRemoveIcon as FolderRemoveIconSolid,
	GiftIcon as GiftIconSolid,
	GlobeAltIcon as GlobeAltIconSolid,
	GlobeIcon as GlobeIconSolid,
	HandIcon as HandIconSolid,
	HashtagIcon as HashtagIconSolid,
	HeartIcon as HeartIconSolid,
	HomeIcon as HomeIconSolid,
	IdentificationIcon as IdentificationIconSolid,
	InboxIcon as InboxIconSolid,
	InboxInIcon as InboxInIconSolid,
	InformationCircleIcon as InformationCircleIconSolid,
	KeyIcon as KeyIconSolid,
	LibraryIcon as LibraryIconSolid,
	LightBulbIcon as LightBulbIconSolid,
	LightningBoltIcon as LightningBoltIconSolid,
	LinkIcon as LinkIconSolid,
	LocationMarkerIcon as LocationMarkerIconSolid,
	LockClosedIcon as LockClosedIconSolid,
	LockOpenIcon as LockOpenIconSolid,
	LoginIcon as LoginIconSolid,
	LogoutIcon as LogoutIconSolid,
	MailIcon as MailIconSolid,
	MailOpenIcon as MailOpenIconSolid,
	MapIcon as MapIconSolid,
	MenuAlt1Icon as MenuAlt1IconSolid,
	MenuAlt2Icon as MenuAlt2IconSolid,
	MenuAlt3Icon as MenuAlt3IconSolid,
	MenuAlt4Icon as MenuAlt4IconSolid,
	MenuIcon as MenuIconSolid,
	MicrophoneIcon as MicrophoneIconSolid,
	MinusCircleIcon as MinusCircleIconSolid,
	MinusIcon as MinusIconSolid,
	MinusSmIcon as MinusSmIconSolid,
	MoonIcon as MoonIconSolid,
	MusicNoteIcon as MusicNoteIconSolid,
	NewspaperIcon as NewspaperIconSolid,
	OfficeBuildingIcon as OfficeBuildingIconSolid,
	PaperAirplaneIcon as PaperAirplaneIconSolid,
	PaperClipIcon as PaperClipIconSolid,
	PauseIcon as PauseIconSolid,
	PencilAltIcon as PencilAltIconSolid,
	PencilIcon as PencilIconSolid,
	PhoneIcon as PhoneIconSolid,
	PhoneIncomingIcon as PhoneIncomingIconSolid,
	PhoneMissedCallIcon as PhoneMissedCallIconSolid,
	PhoneOutgoingIcon as PhoneOutgoingIconSolid,
	PhotographIcon as PhotographIconSolid,
	PlayIcon as PlayIconSolid,
	PlusCircleIcon as PlusCircleIconSolid,
	PlusIcon as PlusIconSolid,
	PlusSmIcon as PlusSmIconSolid,
	PresentationChartBarIcon as PresentationChartBarIconSolid,
	PresentationChartLineIcon as PresentationChartLineIconSolid,
	PrinterIcon as PrinterIconSolid,
	PuzzleIcon as PuzzleIconSolid,
	QrcodeIcon as QrcodeIconSolid,
	QuestionMarkCircleIcon as QuestionMarkCircleIconSolid,
	ReceiptRefundIcon as ReceiptRefundIconSolid,
	ReceiptTaxIcon as ReceiptTaxIconSolid,
	RefreshIcon as RefreshIconSolid,
	ReplyIcon as ReplyIconSolid,
	RewindIcon as RewindIconSolid,
	RssIcon as RssIconSolid,
	SaveAsIcon as SaveAsIconSolid,
	SaveIcon as SaveIconSolid,
	ScaleIcon as ScaleIconSolid,
	ScissorsIcon as ScissorsIconSolid,
	SearchCircleIcon as SearchCircleIconSolid,
	SearchIcon as SearchIconSolid,
	SelectorIcon as SelectorIconSolid,
	ServerIcon as ServerIconSolid,
	ShareIcon as ShareIconSolid,
	ShieldCheckIcon as ShieldCheckIconSolid,
	ShieldExclamationIcon as ShieldExclamationIconSolid,
	ShoppingBagIcon as ShoppingBagIconSolid,
	ShoppingCartIcon as ShoppingCartIconSolid,
	SortAscendingIcon as SortAscendingIconSolid,
	SortDescendingIcon as SortDescendingIconSolid,
	SparklesIcon as SparklesIconSolid,
	SpeakerphoneIcon as SpeakerphoneIconSolid,
	StarIcon as StarIconSolid,
	StatusOfflineIcon as StatusOfflineIconSolid,
	StatusOnlineIcon as StatusOnlineIconSolid,
	StopIcon as StopIconSolid,
	SunIcon as SunIconSolid,
	SupportIcon as SupportIconSolid,
	SwitchHorizontalIcon as SwitchHorizontalIconSolid,
	SwitchVerticalIcon as SwitchVerticalIconSolid,
	TableIcon as TableIconSolid,
	TagIcon as TagIconSolid,
	TemplateIcon as TemplateIconSolid,
	TerminalIcon as TerminalIconSolid,
	ThumbDownIcon as ThumbDownIconSolid,
	ThumbUpIcon as ThumbUpIconSolid,
	TicketIcon as TicketIconSolid,
	TranslateIcon as TranslateIconSolid,
	TrashIcon as TrashIconSolid,
	TrendingDownIcon as TrendingDownIconSolid,
	TrendingUpIcon as TrendingUpIconSolid,
	TruckIcon as TruckIconSolid,
	UploadIcon as UploadIconSolid,
	UserAddIcon as UserAddIconSolid,
	UserCircleIcon as UserCircleIconSolid,
	UserGroupIcon as UserGroupIconSolid,
	UserIcon as UserIconSolid,
	UserRemoveIcon as UserRemoveIconSolid,
	UsersIcon as UsersIconSolid,
	VariableIcon as VariableIconSolid,
	VideoCameraIcon as VideoCameraIconSolid,
	ViewBoardsIcon as ViewBoardsIconSolid,
	ViewGridAddIcon as ViewGridAddIconSolid,
	ViewGridIcon as ViewGridIconSolid,
	ViewListIcon as ViewListIconSolid,
	VolumeOffIcon as VolumeOffIconSolid,
	VolumeUpIcon as VolumeUpIconSolid,
	WifiIcon as WifiIconSolid,
	XCircleIcon as XCircleIconSolid,
	XIcon as XIconSolid,
	ZoomInIcon as ZoomInIconSolid,
	ZoomOutIcon as ZoomOutIconSolid,
} from '@heroicons/react/solid';

import { createIconFromBase } from '../lib/icon';

export const AcademicCapOutline = createIconFromBase(AcademicCapIconOutline, {
	name: 'AcademicCapOutline',
});
export const AcademicCapSolid = createIconFromBase(AcademicCapIconSolid, {
	name: 'AcademicCapSolid',
});
export const AdjustmentsOutline = createIconFromBase(AdjustmentsIconOutline, {
	name: 'AdjustmentsOutline',
});
export const AdjustmentsSolid = createIconFromBase(AdjustmentsIconSolid, {
	name: 'AdjustmentsSolid',
});
export const AnnotationOutline = createIconFromBase(AnnotationIconOutline, {
	name: 'AnnotationOutline',
});
export const AnnotationSolid = createIconFromBase(AnnotationIconSolid, { name: 'AnnotationSolid' });
export const ArchiveOutline = createIconFromBase(ArchiveIconOutline, { name: 'ArchiveOutline' });
export const ArchiveSolid = createIconFromBase(ArchiveIconSolid, { name: 'ArchiveSolid' });
export const ArrowCircleDownOutline = createIconFromBase(ArrowCircleDownIconOutline, {
	name: 'ArrowCircleDownOutline',
});
export const ArrowCircleDownSolid = createIconFromBase(ArrowCircleDownIconSolid, {
	name: 'ArrowCircleDownSolid',
});
export const ArrowCircleLeftOutline = createIconFromBase(ArrowCircleLeftIconOutline, {
	name: 'ArrowCircleLeftOutline',
});
export const ArrowCircleLeftSolid = createIconFromBase(ArrowCircleLeftIconSolid, {
	name: 'ArrowCircleLeftSolid',
});
export const ArrowCircleRightOutline = createIconFromBase(ArrowCircleRightIconOutline, {
	name: 'ArrowCircleRightOutline',
});
export const ArrowCircleRightSolid = createIconFromBase(ArrowCircleRightIconSolid, {
	name: 'ArrowCircleRightSolid',
});
export const ArrowCircleUpOutline = createIconFromBase(ArrowCircleUpIconOutline, {
	name: 'ArrowCircleUpOutline',
});
export const ArrowCircleUpSolid = createIconFromBase(ArrowCircleUpIconSolid, {
	name: 'ArrowCircleUpSolid',
});
export const ArrowDownOutline = createIconFromBase(ArrowDownIconOutline, {
	name: 'ArrowDownOutline',
});
export const ArrowDownSolid = createIconFromBase(ArrowDownIconSolid, { name: 'ArrowDownSolid' });
export const ArrowLeftOutline = createIconFromBase(ArrowLeftIconOutline, {
	name: 'ArrowLeftOutline',
});
export const ArrowLeftSolid = createIconFromBase(ArrowLeftIconSolid, { name: 'ArrowLeftSolid' });
export const ArrowNarrowDownOutline = createIconFromBase(ArrowNarrowDownIconOutline, {
	name: 'ArrowNarrowDownOutline',
});
export const ArrowNarrowDownSolid = createIconFromBase(ArrowNarrowDownIconSolid, {
	name: 'ArrowNarrowDownSolid',
});
export const ArrowNarrowLeftOutline = createIconFromBase(ArrowNarrowLeftIconOutline, {
	name: 'ArrowNarrowLeftOutline',
});
export const ArrowNarrowLeftSolid = createIconFromBase(ArrowNarrowLeftIconSolid, {
	name: 'ArrowNarrowLeftSolid',
});
export const ArrowNarrowRightOutline = createIconFromBase(ArrowNarrowRightIconOutline, {
	name: 'ArrowNarrowRightOutline',
});
export const ArrowNarrowRightSolid = createIconFromBase(ArrowNarrowRightIconSolid, {
	name: 'ArrowNarrowRightSolid',
});
export const ArrowNarrowUpOutline = createIconFromBase(ArrowNarrowUpIconOutline, {
	name: 'ArrowNarrowUpOutline',
});
export const ArrowNarrowUpSolid = createIconFromBase(ArrowNarrowUpIconSolid, {
	name: 'ArrowNarrowUpSolid',
});
export const ArrowRightOutline = createIconFromBase(ArrowRightIconOutline, {
	name: 'ArrowRightOutline',
});
export const ArrowRightSolid = createIconFromBase(ArrowRightIconSolid, { name: 'ArrowRightSolid' });
export const ArrowSmDownOutline = createIconFromBase(ArrowSmDownIconOutline, {
	name: 'ArrowSmDownOutline',
});
export const ArrowSmDownSolid = createIconFromBase(ArrowSmDownIconSolid, {
	name: 'ArrowSmDownSolid',
});
export const ArrowSmLeftOutline = createIconFromBase(ArrowSmLeftIconOutline, {
	name: 'ArrowSmLeftOutline',
});
export const ArrowSmLeftSolid = createIconFromBase(ArrowSmLeftIconSolid, {
	name: 'ArrowSmLeftSolid',
});
export const ArrowSmRightOutline = createIconFromBase(ArrowSmRightIconOutline, {
	name: 'ArrowSmRightOutline',
});
export const ArrowSmRightSolid = createIconFromBase(ArrowSmRightIconSolid, {
	name: 'ArrowSmRightSolid',
});
export const ArrowSmUpOutline = createIconFromBase(ArrowSmUpIconOutline, {
	name: 'ArrowSmUpOutline',
});
export const ArrowSmUpSolid = createIconFromBase(ArrowSmUpIconSolid, { name: 'ArrowSmUpSolid' });
export const ArrowUpOutline = createIconFromBase(ArrowUpIconOutline, { name: 'ArrowUpOutline' });
export const ArrowUpSolid = createIconFromBase(ArrowUpIconSolid, { name: 'ArrowUpSolid' });
export const ArrowsExpandOutline = createIconFromBase(ArrowsExpandIconOutline, {
	name: 'ArrowsExpandOutline',
});
export const ArrowsExpandSolid = createIconFromBase(ArrowsExpandIconSolid, {
	name: 'ArrowsExpandSolid',
});
export const AtSymbolOutline = createIconFromBase(AtSymbolIconOutline, { name: 'AtSymbolOutline' });
export const AtSymbolSolid = createIconFromBase(AtSymbolIconSolid, { name: 'AtSymbolSolid' });
export const BackspaceOutline = createIconFromBase(BackspaceIconOutline, {
	name: 'BackspaceOutline',
});
export const BackspaceSolid = createIconFromBase(BackspaceIconSolid, { name: 'BackspaceSolid' });
export const BadgeCheckOutline = createIconFromBase(BadgeCheckIconOutline, {
	name: 'BadgeCheckOutline',
});
export const BadgeCheckSolid = createIconFromBase(BadgeCheckIconSolid, { name: 'BadgeCheckSolid' });
export const BanOutline = createIconFromBase(BanIconOutline, { name: 'BanOutline' });
export const BanSolid = createIconFromBase(BanIconSolid, { name: 'BanSolid' });
export const BeakerOutline = createIconFromBase(BeakerIconOutline, { name: 'BeakerOutline' });
export const BeakerSolid = createIconFromBase(BeakerIconSolid, { name: 'BeakerSolid' });
export const BellOutline = createIconFromBase(BellIconOutline, { name: 'BellOutline' });
export const BellSolid = createIconFromBase(BellIconSolid, { name: 'BellSolid' });
export const BookOpenOutline = createIconFromBase(BookOpenIconOutline, { name: 'BookOpenOutline' });
export const BookOpenSolid = createIconFromBase(BookOpenIconSolid, { name: 'BookOpenSolid' });
export const BookmarkAltOutline = createIconFromBase(BookmarkAltIconOutline, {
	name: 'BookmarkAltOutline',
});
export const BookmarkAltSolid = createIconFromBase(BookmarkAltIconSolid, {
	name: 'BookmarkAltSolid',
});
export const BookmarkOutline = createIconFromBase(BookmarkIconOutline, { name: 'BookmarkOutline' });
export const BookmarkSolid = createIconFromBase(BookmarkIconSolid, { name: 'BookmarkSolid' });
export const BriefcaseOutline = createIconFromBase(BriefcaseIconOutline, {
	name: 'BriefcaseOutline',
});
export const BriefcaseSolid = createIconFromBase(BriefcaseIconSolid, { name: 'BriefcaseSolid' });
export const CakeOutline = createIconFromBase(CakeIconOutline, { name: 'CakeOutline' });
export const CakeSolid = createIconFromBase(CakeIconSolid, { name: 'CakeSolid' });
export const CalculatorOutline = createIconFromBase(CalculatorIconOutline, {
	name: 'CalculatorOutline',
});
export const CalculatorSolid = createIconFromBase(CalculatorIconSolid, { name: 'CalculatorSolid' });
export const CalendarOutline = createIconFromBase(CalendarIconOutline, { name: 'CalendarOutline' });
export const CalendarSolid = createIconFromBase(CalendarIconSolid, { name: 'CalendarSolid' });
export const CameraOutline = createIconFromBase(CameraIconOutline, { name: 'CameraOutline' });
export const CameraSolid = createIconFromBase(CameraIconSolid, { name: 'CameraSolid' });
export const CashOutline = createIconFromBase(CashIconOutline, { name: 'CashOutline' });
export const CashSolid = createIconFromBase(CashIconSolid, { name: 'CashSolid' });
export const ChartBarOutline = createIconFromBase(ChartBarIconOutline, { name: 'ChartBarOutline' });
export const ChartBarSolid = createIconFromBase(ChartBarIconSolid, { name: 'ChartBarSolid' });
export const ChartPieOutline = createIconFromBase(ChartPieIconOutline, { name: 'ChartPieOutline' });
export const ChartPieSolid = createIconFromBase(ChartPieIconSolid, { name: 'ChartPieSolid' });
export const ChartSquareBarOutline = createIconFromBase(ChartSquareBarIconOutline, {
	name: 'ChartSquareBarOutline',
});
export const ChartSquareBarSolid = createIconFromBase(ChartSquareBarIconSolid, {
	name: 'ChartSquareBarSolid',
});
export const ChatAlt2Outline = createIconFromBase(ChatAlt2IconOutline, { name: 'ChatAlt2Outline' });
export const ChatAlt2Solid = createIconFromBase(ChatAlt2IconSolid, { name: 'ChatAlt2Solid' });
export const ChatAltOutline = createIconFromBase(ChatAltIconOutline, { name: 'ChatAltOutline' });
export const ChatAltSolid = createIconFromBase(ChatAltIconSolid, { name: 'ChatAltSolid' });
export const ChatOutline = createIconFromBase(ChatIconOutline, { name: 'ChatOutline' });
export const ChatSolid = createIconFromBase(ChatIconSolid, { name: 'ChatSolid' });
export const CheckCircleOutline = createIconFromBase(CheckCircleIconOutline, {
	name: 'CheckCircleOutline',
});
export const CheckCircleSolid = createIconFromBase(CheckCircleIconSolid, {
	name: 'CheckCircleSolid',
});
export const CheckOutline = createIconFromBase(CheckIconOutline, { name: 'CheckOutline' });
export const CheckSolid = createIconFromBase(CheckIconSolid, { name: 'CheckSolid' });
export const ChevronDoubleDownOutline = createIconFromBase(ChevronDoubleDownIconOutline, {
	name: 'ChevronDoubleDownOutline',
});
export const ChevronDoubleDownSolid = createIconFromBase(ChevronDoubleDownIconSolid, {
	name: 'ChevronDoubleDownSolid',
});
export const ChevronDoubleLeftOutline = createIconFromBase(ChevronDoubleLeftIconOutline, {
	name: 'ChevronDoubleLeftOutline',
});
export const ChevronDoubleLeftSolid = createIconFromBase(ChevronDoubleLeftIconSolid, {
	name: 'ChevronDoubleLeftSolid',
});
export const ChevronDoubleRightOutline = createIconFromBase(ChevronDoubleRightIconOutline, {
	name: 'ChevronDoubleRightOutline',
});
export const ChevronDoubleRightSolid = createIconFromBase(ChevronDoubleRightIconSolid, {
	name: 'ChevronDoubleRightSolid',
});
export const ChevronDoubleUpOutline = createIconFromBase(ChevronDoubleUpIconOutline, {
	name: 'ChevronDoubleUpOutline',
});
export const ChevronDoubleUpSolid = createIconFromBase(ChevronDoubleUpIconSolid, {
	name: 'ChevronDoubleUpSolid',
});
export const ChevronDownOutline = createIconFromBase(ChevronDownIconOutline, {
	name: 'ChevronDownOutline',
});
export const ChevronDownSolid = createIconFromBase(ChevronDownIconSolid, {
	name: 'ChevronDownSolid',
});
export const ChevronLeftOutline = createIconFromBase(ChevronLeftIconOutline, {
	name: 'ChevronLeftOutline',
});
export const ChevronLeftSolid = createIconFromBase(ChevronLeftIconSolid, {
	name: 'ChevronLeftSolid',
});
export const ChevronRightOutline = createIconFromBase(ChevronRightIconOutline, {
	name: 'ChevronRightOutline',
});
export const ChevronRightSolid = createIconFromBase(ChevronRightIconSolid, {
	name: 'ChevronRightSolid',
});
export const ChevronUpOutline = createIconFromBase(ChevronUpIconOutline, {
	name: 'ChevronUpOutline',
});
export const ChevronUpSolid = createIconFromBase(ChevronUpIconSolid, { name: 'ChevronUpSolid' });
export const ChipOutline = createIconFromBase(ChipIconOutline, { name: 'ChipOutline' });
export const ChipSolid = createIconFromBase(ChipIconSolid, { name: 'ChipSolid' });
export const ClipboardCheckOutline = createIconFromBase(ClipboardCheckIconOutline, {
	name: 'ClipboardCheckOutline',
});
export const ClipboardCheckSolid = createIconFromBase(ClipboardCheckIconSolid, {
	name: 'ClipboardCheckSolid',
});
export const ClipboardCopyOutline = createIconFromBase(ClipboardCopyIconOutline, {
	name: 'ClipboardCopyOutline',
});
export const ClipboardCopySolid = createIconFromBase(ClipboardCopyIconSolid, {
	name: 'ClipboardCopySolid',
});
export const ClipboardListOutline = createIconFromBase(ClipboardListIconOutline, {
	name: 'ClipboardListOutline',
});
export const ClipboardListSolid = createIconFromBase(ClipboardListIconSolid, {
	name: 'ClipboardListSolid',
});
export const ClipboardOutline = createIconFromBase(ClipboardIconOutline, {
	name: 'ClipboardOutline',
});
export const ClipboardSolid = createIconFromBase(ClipboardIconSolid, { name: 'ClipboardSolid' });
export const ClockOutline = createIconFromBase(ClockIconOutline, { name: 'ClockOutline' });
export const ClockSolid = createIconFromBase(ClockIconSolid, { name: 'ClockSolid' });
export const CloudDownloadOutline = createIconFromBase(CloudDownloadIconOutline, {
	name: 'CloudDownloadOutline',
});
export const CloudDownloadSolid = createIconFromBase(CloudDownloadIconSolid, {
	name: 'CloudDownloadSolid',
});
export const CloudUploadOutline = createIconFromBase(CloudUploadIconOutline, {
	name: 'CloudUploadOutline',
});
export const CloudUploadSolid = createIconFromBase(CloudUploadIconSolid, {
	name: 'CloudUploadSolid',
});
export const CloudOutline = createIconFromBase(CloudIconOutline, { name: 'CloudOutline' });
export const CloudSolid = createIconFromBase(CloudIconSolid, { name: 'CloudSolid' });
export const CodeOutline = createIconFromBase(CodeIconOutline, { name: 'CodeOutline' });
export const CodeSolid = createIconFromBase(CodeIconSolid, { name: 'CodeSolid' });
export const CogOutline = createIconFromBase(CogIconOutline, { name: 'CogOutline' });
export const CogSolid = createIconFromBase(CogIconSolid, { name: 'CogSolid' });
export const CollectionOutline = createIconFromBase(CollectionIconOutline, {
	name: 'CollectionOutline',
});
export const CollectionSolid = createIconFromBase(CollectionIconSolid, { name: 'CollectionSolid' });
export const ColorSwatchOutline = createIconFromBase(ColorSwatchIconOutline, {
	name: 'ColorSwatchOutline',
});
export const ColorSwatchSolid = createIconFromBase(ColorSwatchIconSolid, {
	name: 'ColorSwatchSolid',
});
export const CreditCardOutline = createIconFromBase(CreditCardIconOutline, {
	name: 'CreditCardOutline',
});
export const CreditCardSolid = createIconFromBase(CreditCardIconSolid, { name: 'CreditCardSolid' });
export const CubeTransparentOutline = createIconFromBase(CubeTransparentIconOutline, {
	name: 'CubeTransparentOutline',
});
export const CubeTransparentSolid = createIconFromBase(CubeTransparentIconSolid, {
	name: 'CubeTransparentSolid',
});
export const CubeOutline = createIconFromBase(CubeIconOutline, { name: 'CubeOutline' });
export const CubeSolid = createIconFromBase(CubeIconSolid, { name: 'CubeSolid' });
export const CurrencyBangladeshiOutline = createIconFromBase(CurrencyBangladeshiIconOutline, {
	name: 'CurrencyBangladeshiOutline',
});
export const CurrencyBangladeshiSolid = createIconFromBase(CurrencyBangladeshiIconSolid, {
	name: 'CurrencyBangladeshiSolid',
});
export const CurrencyDollarOutline = createIconFromBase(CurrencyDollarIconOutline, {
	name: 'CurrencyDollarOutline',
});
export const CurrencyDollarSolid = createIconFromBase(CurrencyDollarIconSolid, {
	name: 'CurrencyDollarSolid',
});
export const CurrencyEuroOutline = createIconFromBase(CurrencyEuroIconOutline, {
	name: 'CurrencyEuroOutline',
});
export const CurrencyEuroSolid = createIconFromBase(CurrencyEuroIconSolid, {
	name: 'CurrencyEuroSolid',
});
export const CurrencyPoundOutline = createIconFromBase(CurrencyPoundIconOutline, {
	name: 'CurrencyPoundOutline',
});
export const CurrencyPoundSolid = createIconFromBase(CurrencyPoundIconSolid, {
	name: 'CurrencyPoundSolid',
});
export const CurrencyRupeeOutline = createIconFromBase(CurrencyRupeeIconOutline, {
	name: 'CurrencyRupeeOutline',
});
export const CurrencyRupeeSolid = createIconFromBase(CurrencyRupeeIconSolid, {
	name: 'CurrencyRupeeSolid',
});
export const CurrencyYenOutline = createIconFromBase(CurrencyYenIconOutline, {
	name: 'CurrencyYenOutline',
});
export const CurrencyYenSolid = createIconFromBase(CurrencyYenIconSolid, {
	name: 'CurrencyYenSolid',
});
export const CursorClickOutline = createIconFromBase(CursorClickIconOutline, {
	name: 'CursorClickOutline',
});
export const CursorClickSolid = createIconFromBase(CursorClickIconSolid, {
	name: 'CursorClickSolid',
});
export const DatabaseOutline = createIconFromBase(DatabaseIconOutline, { name: 'DatabaseOutline' });
export const DatabaseSolid = createIconFromBase(DatabaseIconSolid, { name: 'DatabaseSolid' });
export const DesktopComputerOutline = createIconFromBase(DesktopComputerIconOutline, {
	name: 'DesktopComputerOutline',
});
export const DesktopComputerSolid = createIconFromBase(DesktopComputerIconSolid, {
	name: 'DesktopComputerSolid',
});
export const DeviceMobileOutline = createIconFromBase(DeviceMobileIconOutline, {
	name: 'DeviceMobileOutline',
});
export const DeviceMobileSolid = createIconFromBase(DeviceMobileIconSolid, {
	name: 'DeviceMobileSolid',
});
export const DeviceTabletOutline = createIconFromBase(DeviceTabletIconOutline, {
	name: 'DeviceTabletOutline',
});
export const DeviceTabletSolid = createIconFromBase(DeviceTabletIconSolid, {
	name: 'DeviceTabletSolid',
});
export const DocumentAddOutline = createIconFromBase(DocumentAddIconOutline, {
	name: 'DocumentAddOutline',
});
export const DocumentAddSolid = createIconFromBase(DocumentAddIconSolid, {
	name: 'DocumentAddSolid',
});
export const DocumentDownloadOutline = createIconFromBase(DocumentDownloadIconOutline, {
	name: 'DocumentDownloadOutline',
});
export const DocumentDownloadSolid = createIconFromBase(DocumentDownloadIconSolid, {
	name: 'DocumentDownloadSolid',
});
export const DocumentDuplicateOutline = createIconFromBase(DocumentDuplicateIconOutline, {
	name: 'DocumentDuplicateOutline',
});
export const DocumentDuplicateSolid = createIconFromBase(DocumentDuplicateIconSolid, {
	name: 'DocumentDuplicateSolid',
});
export const DocumentRemoveOutline = createIconFromBase(DocumentRemoveIconOutline, {
	name: 'DocumentRemoveOutline',
});
export const DocumentRemoveSolid = createIconFromBase(DocumentRemoveIconSolid, {
	name: 'DocumentRemoveSolid',
});
export const DocumentReportOutline = createIconFromBase(DocumentReportIconOutline, {
	name: 'DocumentReportOutline',
});
export const DocumentReportSolid = createIconFromBase(DocumentReportIconSolid, {
	name: 'DocumentReportSolid',
});
export const DocumentSearchOutline = createIconFromBase(DocumentSearchIconOutline, {
	name: 'DocumentSearchOutline',
});
export const DocumentSearchSolid = createIconFromBase(DocumentSearchIconSolid, {
	name: 'DocumentSearchSolid',
});
export const DocumentTextOutline = createIconFromBase(DocumentTextIconOutline, {
	name: 'DocumentTextOutline',
});
export const DocumentTextSolid = createIconFromBase(DocumentTextIconSolid, {
	name: 'DocumentTextSolid',
});
export const DocumentOutline = createIconFromBase(DocumentIconOutline, { name: 'DocumentOutline' });
export const DocumentSolid = createIconFromBase(DocumentIconSolid, { name: 'DocumentSolid' });
export const DotsCircleHorizontalOutline = createIconFromBase(DotsCircleHorizontalIconOutline, {
	name: 'DotsCircleHorizontalOutline',
});
export const DotsCircleHorizontalSolid = createIconFromBase(DotsCircleHorizontalIconSolid, {
	name: 'DotsCircleHorizontalSolid',
});
export const DotsHorizontalOutline = createIconFromBase(DotsHorizontalIconOutline, {
	name: 'DotsHorizontalOutline',
});
export const DotsHorizontalSolid = createIconFromBase(DotsHorizontalIconSolid, {
	name: 'DotsHorizontalSolid',
});
export const DotsVerticalOutline = createIconFromBase(DotsVerticalIconOutline, {
	name: 'DotsVerticalOutline',
});
export const DotsVerticalSolid = createIconFromBase(DotsVerticalIconSolid, {
	name: 'DotsVerticalSolid',
});
export const DownloadOutline = createIconFromBase(DownloadIconOutline, { name: 'DownloadOutline' });
export const DownloadSolid = createIconFromBase(DownloadIconSolid, { name: 'DownloadSolid' });
export const DuplicateOutline = createIconFromBase(DuplicateIconOutline, {
	name: 'DuplicateOutline',
});
export const DuplicateSolid = createIconFromBase(DuplicateIconSolid, { name: 'DuplicateSolid' });
export const EmojiHappyOutline = createIconFromBase(EmojiHappyIconOutline, {
	name: 'EmojiHappyOutline',
});
export const EmojiHappySolid = createIconFromBase(EmojiHappyIconSolid, { name: 'EmojiHappySolid' });
export const EmojiSadOutline = createIconFromBase(EmojiSadIconOutline, { name: 'EmojiSadOutline' });
export const EmojiSadSolid = createIconFromBase(EmojiSadIconSolid, { name: 'EmojiSadSolid' });
export const ExclamationCircleOutline = createIconFromBase(ExclamationCircleIconOutline, {
	name: 'ExclamationCircleOutline',
});
export const ExclamationCircleSolid = createIconFromBase(ExclamationCircleIconSolid, {
	name: 'ExclamationCircleSolid',
});
export const ExclamationOutline = createIconFromBase(ExclamationIconOutline, {
	name: 'ExclamationOutline',
});
export const ExclamationSolid = createIconFromBase(ExclamationIconSolid, {
	name: 'ExclamationSolid',
});
export const ExternalLinkOutline = createIconFromBase(ExternalLinkIconOutline, {
	name: 'ExternalLinkOutline',
});
export const ExternalLinkSolid = createIconFromBase(ExternalLinkIconSolid, {
	name: 'ExternalLinkSolid',
});
export const EyeOffOutline = createIconFromBase(EyeOffIconOutline, { name: 'EyeOffOutline' });
export const EyeOffSolid = createIconFromBase(EyeOffIconSolid, { name: 'EyeOffSolid' });
export const EyeOutline = createIconFromBase(EyeIconOutline, { name: 'EyeOutline' });
export const EyeSolid = createIconFromBase(EyeIconSolid, { name: 'EyeSolid' });
export const FastForwardOutline = createIconFromBase(FastForwardIconOutline, {
	name: 'FastForwardOutline',
});
export const FastForwardSolid = createIconFromBase(FastForwardIconSolid, {
	name: 'FastForwardSolid',
});
export const FilmOutline = createIconFromBase(FilmIconOutline, { name: 'FilmOutline' });
export const FilmSolid = createIconFromBase(FilmIconSolid, { name: 'FilmSolid' });
export const FilterOutline = createIconFromBase(FilterIconOutline, { name: 'FilterOutline' });
export const FilterSolid = createIconFromBase(FilterIconSolid, { name: 'FilterSolid' });
export const FingerPrintOutline = createIconFromBase(FingerPrintIconOutline, {
	name: 'FingerPrintOutline',
});
export const FingerPrintSolid = createIconFromBase(FingerPrintIconSolid, {
	name: 'FingerPrintSolid',
});
export const FireOutline = createIconFromBase(FireIconOutline, { name: 'FireOutline' });
export const FireSolid = createIconFromBase(FireIconSolid, { name: 'FireSolid' });
export const FlagOutline = createIconFromBase(FlagIconOutline, { name: 'FlagOutline' });
export const FlagSolid = createIconFromBase(FlagIconSolid, { name: 'FlagSolid' });
export const FolderAddOutline = createIconFromBase(FolderAddIconOutline, {
	name: 'FolderAddOutline',
});
export const FolderAddSolid = createIconFromBase(FolderAddIconSolid, { name: 'FolderAddSolid' });
export const FolderDownloadOutline = createIconFromBase(FolderDownloadIconOutline, {
	name: 'FolderDownloadOutline',
});
export const FolderDownloadSolid = createIconFromBase(FolderDownloadIconSolid, {
	name: 'FolderDownloadSolid',
});
export const FolderOpenOutline = createIconFromBase(FolderOpenIconOutline, {
	name: 'FolderOpenOutline',
});
export const FolderOpenSolid = createIconFromBase(FolderOpenIconSolid, { name: 'FolderOpenSolid' });
export const FolderRemoveOutline = createIconFromBase(FolderRemoveIconOutline, {
	name: 'FolderRemoveOutline',
});
export const FolderRemoveSolid = createIconFromBase(FolderRemoveIconSolid, {
	name: 'FolderRemoveSolid',
});
export const FolderOutline = createIconFromBase(FolderIconOutline, { name: 'FolderOutline' });
export const FolderSolid = createIconFromBase(FolderIconSolid, { name: 'FolderSolid' });
export const GiftOutline = createIconFromBase(GiftIconOutline, { name: 'GiftOutline' });
export const GiftSolid = createIconFromBase(GiftIconSolid, { name: 'GiftSolid' });
export const GlobeAltOutline = createIconFromBase(GlobeAltIconOutline, { name: 'GlobeAltOutline' });
export const GlobeAltSolid = createIconFromBase(GlobeAltIconSolid, { name: 'GlobeAltSolid' });
export const GlobeOutline = createIconFromBase(GlobeIconOutline, { name: 'GlobeOutline' });
export const GlobeSolid = createIconFromBase(GlobeIconSolid, { name: 'GlobeSolid' });
export const HandOutline = createIconFromBase(HandIconOutline, { name: 'HandOutline' });
export const HandSolid = createIconFromBase(HandIconSolid, { name: 'HandSolid' });
export const HashtagOutline = createIconFromBase(HashtagIconOutline, { name: 'HashtagOutline' });
export const HashtagSolid = createIconFromBase(HashtagIconSolid, { name: 'HashtagSolid' });
export const HeartOutline = createIconFromBase(HeartIconOutline, { name: 'HeartOutline' });
export const HeartSolid = createIconFromBase(HeartIconSolid, { name: 'HeartSolid' });
export const HomeOutline = createIconFromBase(HomeIconOutline, { name: 'HomeOutline' });
export const HomeSolid = createIconFromBase(HomeIconSolid, { name: 'HomeSolid' });
export const IdentificationOutline = createIconFromBase(IdentificationIconOutline, {
	name: 'IdentificationOutline',
});
export const IdentificationSolid = createIconFromBase(IdentificationIconSolid, {
	name: 'IdentificationSolid',
});
export const InboxInOutline = createIconFromBase(InboxInIconOutline, { name: 'InboxInOutline' });
export const InboxInSolid = createIconFromBase(InboxInIconSolid, { name: 'InboxInSolid' });
export const InboxOutline = createIconFromBase(InboxIconOutline, { name: 'InboxOutline' });
export const InboxSolid = createIconFromBase(InboxIconSolid, { name: 'InboxSolid' });
export const InformationCircleOutline = createIconFromBase(InformationCircleIconOutline, {
	name: 'InformationCircleOutline',
});
export const InformationCircleSolid = createIconFromBase(InformationCircleIconSolid, {
	name: 'InformationCircleSolid',
});
export const KeyOutline = createIconFromBase(KeyIconOutline, { name: 'KeyOutline' });
export const KeySolid = createIconFromBase(KeyIconSolid, { name: 'KeySolid' });
export const LibraryOutline = createIconFromBase(LibraryIconOutline, { name: 'LibraryOutline' });
export const LibrarySolid = createIconFromBase(LibraryIconSolid, { name: 'LibrarySolid' });
export const LightBulbOutline = createIconFromBase(LightBulbIconOutline, {
	name: 'LightBulbOutline',
});
export const LightBulbSolid = createIconFromBase(LightBulbIconSolid, { name: 'LightBulbSolid' });
export const LightningBoltOutline = createIconFromBase(LightningBoltIconOutline, {
	name: 'LightningBoltOutline',
});
export const LightningBoltSolid = createIconFromBase(LightningBoltIconSolid, {
	name: 'LightningBoltSolid',
});
export const LinkOutline = createIconFromBase(LinkIconOutline, { name: 'LinkOutline' });
export const LinkSolid = createIconFromBase(LinkIconSolid, { name: 'LinkSolid' });
export const LocationMarkerOutline = createIconFromBase(LocationMarkerIconOutline, {
	name: 'LocationMarkerOutline',
});
export const LocationMarkerSolid = createIconFromBase(LocationMarkerIconSolid, {
	name: 'LocationMarkerSolid',
});
export const LockClosedOutline = createIconFromBase(LockClosedIconOutline, {
	name: 'LockClosedOutline',
});
export const LockClosedSolid = createIconFromBase(LockClosedIconSolid, { name: 'LockClosedSolid' });
export const LockOpenOutline = createIconFromBase(LockOpenIconOutline, { name: 'LockOpenOutline' });
export const LockOpenSolid = createIconFromBase(LockOpenIconSolid, { name: 'LockOpenSolid' });
export const LoginOutline = createIconFromBase(LoginIconOutline, { name: 'LoginOutline' });
export const LoginSolid = createIconFromBase(LoginIconSolid, { name: 'LoginSolid' });
export const LogoutOutline = createIconFromBase(LogoutIconOutline, { name: 'LogoutOutline' });
export const LogoutSolid = createIconFromBase(LogoutIconSolid, { name: 'LogoutSolid' });
export const MailOpenOutline = createIconFromBase(MailOpenIconOutline, { name: 'MailOpenOutline' });
export const MailOpenSolid = createIconFromBase(MailOpenIconSolid, { name: 'MailOpenSolid' });
export const MailOutline = createIconFromBase(MailIconOutline, { name: 'MailOutline' });
export const MailSolid = createIconFromBase(MailIconSolid, { name: 'MailSolid' });
export const MapOutline = createIconFromBase(MapIconOutline, { name: 'MapOutline' });
export const MapSolid = createIconFromBase(MapIconSolid, { name: 'MapSolid' });
export const MenuAlt1Outline = createIconFromBase(MenuAlt1IconOutline, { name: 'MenuAlt1Outline' });
export const MenuAlt1Solid = createIconFromBase(MenuAlt1IconSolid, { name: 'MenuAlt1Solid' });
export const MenuAlt2Outline = createIconFromBase(MenuAlt2IconOutline, { name: 'MenuAlt2Outline' });
export const MenuAlt2Solid = createIconFromBase(MenuAlt2IconSolid, { name: 'MenuAlt2Solid' });
export const MenuAlt3Outline = createIconFromBase(MenuAlt3IconOutline, { name: 'MenuAlt3Outline' });
export const MenuAlt3Solid = createIconFromBase(MenuAlt3IconSolid, { name: 'MenuAlt3Solid' });
export const MenuAlt4Outline = createIconFromBase(MenuAlt4IconOutline, { name: 'MenuAlt4Outline' });
export const MenuAlt4Solid = createIconFromBase(MenuAlt4IconSolid, { name: 'MenuAlt4Solid' });
export const MenuOutline = createIconFromBase(MenuIconOutline, { name: 'MenuOutline' });
export const MenuSolid = createIconFromBase(MenuIconSolid, { name: 'MenuSolid' });
export const MicrophoneOutline = createIconFromBase(MicrophoneIconOutline, {
	name: 'MicrophoneOutline',
});
export const MicrophoneSolid = createIconFromBase(MicrophoneIconSolid, { name: 'MicrophoneSolid' });
export const MinusCircleOutline = createIconFromBase(MinusCircleIconOutline, {
	name: 'MinusCircleOutline',
});
export const MinusCircleSolid = createIconFromBase(MinusCircleIconSolid, {
	name: 'MinusCircleSolid',
});
export const MinusSmOutline = createIconFromBase(MinusSmIconOutline, { name: 'MinusSmOutline' });
export const MinusSmSolid = createIconFromBase(MinusSmIconSolid, { name: 'MinusSmSolid' });
export const MinusOutline = createIconFromBase(MinusIconOutline, { name: 'MinusOutline' });
export const MinusSolid = createIconFromBase(MinusIconSolid, { name: 'MinusSolid' });
export const MoonOutline = createIconFromBase(MoonIconOutline, { name: 'MoonOutline' });
export const MoonSolid = createIconFromBase(MoonIconSolid, { name: 'MoonSolid' });
export const MusicNoteOutline = createIconFromBase(MusicNoteIconOutline, {
	name: 'MusicNoteOutline',
});
export const MusicNoteSolid = createIconFromBase(MusicNoteIconSolid, { name: 'MusicNoteSolid' });
export const NewspaperOutline = createIconFromBase(NewspaperIconOutline, {
	name: 'NewspaperOutline',
});
export const NewspaperSolid = createIconFromBase(NewspaperIconSolid, { name: 'NewspaperSolid' });
export const OfficeBuildingOutline = createIconFromBase(OfficeBuildingIconOutline, {
	name: 'OfficeBuildingOutline',
});
export const OfficeBuildingSolid = createIconFromBase(OfficeBuildingIconSolid, {
	name: 'OfficeBuildingSolid',
});
export const PaperAirplaneOutline = createIconFromBase(PaperAirplaneIconOutline, {
	name: 'PaperAirplaneOutline',
});
export const PaperAirplaneSolid = createIconFromBase(PaperAirplaneIconSolid, {
	name: 'PaperAirplaneSolid',
});
export const PaperClipOutline = createIconFromBase(PaperClipIconOutline, {
	name: 'PaperClipOutline',
});
export const PaperClipSolid = createIconFromBase(PaperClipIconSolid, { name: 'PaperClipSolid' });
export const PauseOutline = createIconFromBase(PauseIconOutline, { name: 'PauseOutline' });
export const PauseSolid = createIconFromBase(PauseIconSolid, { name: 'PauseSolid' });
export const PencilAltOutline = createIconFromBase(PencilAltIconOutline, {
	name: 'PencilAltOutline',
});
export const PencilAltSolid = createIconFromBase(PencilAltIconSolid, { name: 'PencilAltSolid' });
export const PencilOutline = createIconFromBase(PencilIconOutline, { name: 'PencilOutline' });
export const PencilSolid = createIconFromBase(PencilIconSolid, { name: 'PencilSolid' });
export const PhoneIncomingOutline = createIconFromBase(PhoneIncomingIconOutline, {
	name: 'PhoneIncomingOutline',
});
export const PhoneIncomingSolid = createIconFromBase(PhoneIncomingIconSolid, {
	name: 'PhoneIncomingSolid',
});
export const PhoneMissedCallOutline = createIconFromBase(PhoneMissedCallIconOutline, {
	name: 'PhoneMissedCallOutline',
});
export const PhoneMissedCallSolid = createIconFromBase(PhoneMissedCallIconSolid, {
	name: 'PhoneMissedCallSolid',
});
export const PhoneOutgoingOutline = createIconFromBase(PhoneOutgoingIconOutline, {
	name: 'PhoneOutgoingOutline',
});
export const PhoneOutgoingSolid = createIconFromBase(PhoneOutgoingIconSolid, {
	name: 'PhoneOutgoingSolid',
});
export const PhoneOutline = createIconFromBase(PhoneIconOutline, { name: 'PhoneOutline' });
export const PhoneSolid = createIconFromBase(PhoneIconSolid, { name: 'PhoneSolid' });
export const PhotographOutline = createIconFromBase(PhotographIconOutline, {
	name: 'PhotographOutline',
});
export const PhotographSolid = createIconFromBase(PhotographIconSolid, { name: 'PhotographSolid' });
export const PlayOutline = createIconFromBase(PlayIconOutline, { name: 'PlayOutline' });
export const PlaySolid = createIconFromBase(PlayIconSolid, { name: 'PlaySolid' });
export const PlusCircleOutline = createIconFromBase(PlusCircleIconOutline, {
	name: 'PlusCircleOutline',
});
export const PlusCircleSolid = createIconFromBase(PlusCircleIconSolid, { name: 'PlusCircleSolid' });
export const PlusSmOutline = createIconFromBase(PlusSmIconOutline, { name: 'PlusSmOutline' });
export const PlusSmSolid = createIconFromBase(PlusSmIconSolid, { name: 'PlusSmSolid' });
export const PlusOutline = createIconFromBase(PlusIconOutline, { name: 'PlusOutline' });
export const PlusSolid = createIconFromBase(PlusIconSolid, { name: 'PlusSolid' });
export const PresentationChartBarOutline = createIconFromBase(PresentationChartBarIconOutline, {
	name: 'PresentationChartBarOutline',
});
export const PresentationChartBarSolid = createIconFromBase(PresentationChartBarIconSolid, {
	name: 'PresentationChartBarSolid',
});
export const PresentationChartLineOutline = createIconFromBase(PresentationChartLineIconOutline, {
	name: 'PresentationChartLineOutline',
});
export const PresentationChartLineSolid = createIconFromBase(PresentationChartLineIconSolid, {
	name: 'PresentationChartLineSolid',
});
export const PrinterOutline = createIconFromBase(PrinterIconOutline, { name: 'PrinterOutline' });
export const PrinterSolid = createIconFromBase(PrinterIconSolid, { name: 'PrinterSolid' });
export const PuzzleOutline = createIconFromBase(PuzzleIconOutline, { name: 'PuzzleOutline' });
export const PuzzleSolid = createIconFromBase(PuzzleIconSolid, { name: 'PuzzleSolid' });
export const QrcodeOutline = createIconFromBase(QrcodeIconOutline, { name: 'QrcodeOutline' });
export const QrcodeSolid = createIconFromBase(QrcodeIconSolid, { name: 'QrcodeSolid' });
export const QuestionMarkCircleOutline = createIconFromBase(QuestionMarkCircleIconOutline, {
	name: 'QuestionMarkCircleOutline',
});
export const QuestionMarkCircleSolid = createIconFromBase(QuestionMarkCircleIconSolid, {
	name: 'QuestionMarkCircleSolid',
});
export const ReceiptRefundOutline = createIconFromBase(ReceiptRefundIconOutline, {
	name: 'ReceiptRefundOutline',
});
export const ReceiptRefundSolid = createIconFromBase(ReceiptRefundIconSolid, {
	name: 'ReceiptRefundSolid',
});
export const ReceiptTaxOutline = createIconFromBase(ReceiptTaxIconOutline, {
	name: 'ReceiptTaxOutline',
});
export const ReceiptTaxSolid = createIconFromBase(ReceiptTaxIconSolid, { name: 'ReceiptTaxSolid' });
export const RefreshOutline = createIconFromBase(RefreshIconOutline, { name: 'RefreshOutline' });
export const RefreshSolid = createIconFromBase(RefreshIconSolid, { name: 'RefreshSolid' });
export const ReplyOutline = createIconFromBase(ReplyIconOutline, { name: 'ReplyOutline' });
export const ReplySolid = createIconFromBase(ReplyIconSolid, { name: 'ReplySolid' });
export const RewindOutline = createIconFromBase(RewindIconOutline, { name: 'RewindOutline' });
export const RewindSolid = createIconFromBase(RewindIconSolid, { name: 'RewindSolid' });
export const RssOutline = createIconFromBase(RssIconOutline, { name: 'RssOutline' });
export const RssSolid = createIconFromBase(RssIconSolid, { name: 'RssSolid' });
export const SaveAsOutline = createIconFromBase(SaveAsIconOutline, { name: 'SaveAsOutline' });
export const SaveAsSolid = createIconFromBase(SaveAsIconSolid, { name: 'SaveAsSolid' });
export const SaveOutline = createIconFromBase(SaveIconOutline, { name: 'SaveOutline' });
export const SaveSolid = createIconFromBase(SaveIconSolid, { name: 'SaveSolid' });
export const ScaleOutline = createIconFromBase(ScaleIconOutline, { name: 'ScaleOutline' });
export const ScaleSolid = createIconFromBase(ScaleIconSolid, { name: 'ScaleSolid' });
export const ScissorsOutline = createIconFromBase(ScissorsIconOutline, { name: 'ScissorsOutline' });
export const ScissorsSolid = createIconFromBase(ScissorsIconSolid, { name: 'ScissorsSolid' });
export const SearchCircleOutline = createIconFromBase(SearchCircleIconOutline, {
	name: 'SearchCircleOutline',
});
export const SearchCircleSolid = createIconFromBase(SearchCircleIconSolid, {
	name: 'SearchCircleSolid',
});
export const SearchOutline = createIconFromBase(SearchIconOutline, { name: 'SearchOutline' });
export const SearchSolid = createIconFromBase(SearchIconSolid, { name: 'SearchSolid' });
export const SelectorOutline = createIconFromBase(SelectorIconOutline, { name: 'SelectorOutline' });
export const SelectorSolid = createIconFromBase(SelectorIconSolid, { name: 'SelectorSolid' });
export const ServerOutline = createIconFromBase(ServerIconOutline, { name: 'ServerOutline' });
export const ServerSolid = createIconFromBase(ServerIconSolid, { name: 'ServerSolid' });
export const ShareOutline = createIconFromBase(ShareIconOutline, { name: 'ShareOutline' });
export const ShareSolid = createIconFromBase(ShareIconSolid, { name: 'ShareSolid' });
export const ShieldCheckOutline = createIconFromBase(ShieldCheckIconOutline, {
	name: 'ShieldCheckOutline',
});
export const ShieldCheckSolid = createIconFromBase(ShieldCheckIconSolid, {
	name: 'ShieldCheckSolid',
});
export const ShieldExclamationOutline = createIconFromBase(ShieldExclamationIconOutline, {
	name: 'ShieldExclamationOutline',
});
export const ShieldExclamationSolid = createIconFromBase(ShieldExclamationIconSolid, {
	name: 'ShieldExclamationSolid',
});
export const ShoppingBagOutline = createIconFromBase(ShoppingBagIconOutline, {
	name: 'ShoppingBagOutline',
});
export const ShoppingBagSolid = createIconFromBase(ShoppingBagIconSolid, {
	name: 'ShoppingBagSolid',
});
export const ShoppingCartOutline = createIconFromBase(ShoppingCartIconOutline, {
	name: 'ShoppingCartOutline',
});
export const ShoppingCartSolid = createIconFromBase(ShoppingCartIconSolid, {
	name: 'ShoppingCartSolid',
});
export const SortAscendingOutline = createIconFromBase(SortAscendingIconOutline, {
	name: 'SortAscendingOutline',
});
export const SortAscendingSolid = createIconFromBase(SortAscendingIconSolid, {
	name: 'SortAscendingSolid',
});
export const SortDescendingOutline = createIconFromBase(SortDescendingIconOutline, {
	name: 'SortDescendingOutline',
});
export const SortDescendingSolid = createIconFromBase(SortDescendingIconSolid, {
	name: 'SortDescendingSolid',
});
export const SparklesOutline = createIconFromBase(SparklesIconOutline, { name: 'SparklesOutline' });
export const SparklesSolid = createIconFromBase(SparklesIconSolid, { name: 'SparklesSolid' });
export const SpeakerphoneOutline = createIconFromBase(SpeakerphoneIconOutline, {
	name: 'SpeakerphoneOutline',
});
export const SpeakerphoneSolid = createIconFromBase(SpeakerphoneIconSolid, {
	name: 'SpeakerphoneSolid',
});
export const StarOutline = createIconFromBase(StarIconOutline, { name: 'StarOutline' });
export const StarSolid = createIconFromBase(StarIconSolid, { name: 'StarSolid' });
export const StatusOfflineOutline = createIconFromBase(StatusOfflineIconOutline, {
	name: 'StatusOfflineOutline',
});
export const StatusOfflineSolid = createIconFromBase(StatusOfflineIconSolid, {
	name: 'StatusOfflineSolid',
});
export const StatusOnlineOutline = createIconFromBase(StatusOnlineIconOutline, {
	name: 'StatusOnlineOutline',
});
export const StatusOnlineSolid = createIconFromBase(StatusOnlineIconSolid, {
	name: 'StatusOnlineSolid',
});
export const StopOutline = createIconFromBase(StopIconOutline, { name: 'StopOutline' });
export const StopSolid = createIconFromBase(StopIconSolid, { name: 'StopSolid' });
export const SunOutline = createIconFromBase(SunIconOutline, { name: 'SunOutline' });
export const SunSolid = createIconFromBase(SunIconSolid, { name: 'SunSolid' });
export const SupportOutline = createIconFromBase(SupportIconOutline, { name: 'SupportOutline' });
export const SupportSolid = createIconFromBase(SupportIconSolid, { name: 'SupportSolid' });
export const SwitchHorizontalOutline = createIconFromBase(SwitchHorizontalIconOutline, {
	name: 'SwitchHorizontalOutline',
});
export const SwitchHorizontalSolid = createIconFromBase(SwitchHorizontalIconSolid, {
	name: 'SwitchHorizontalSolid',
});
export const SwitchVerticalOutline = createIconFromBase(SwitchVerticalIconOutline, {
	name: 'SwitchVerticalOutline',
});
export const SwitchVerticalSolid = createIconFromBase(SwitchVerticalIconSolid, {
	name: 'SwitchVerticalSolid',
});
export const TableOutline = createIconFromBase(TableIconOutline, { name: 'TableOutline' });
export const TableSolid = createIconFromBase(TableIconSolid, { name: 'TableSolid' });
export const TagOutline = createIconFromBase(TagIconOutline, { name: 'TagOutline' });
export const TagSolid = createIconFromBase(TagIconSolid, { name: 'TagSolid' });
export const TemplateOutline = createIconFromBase(TemplateIconOutline, { name: 'TemplateOutline' });
export const TemplateSolid = createIconFromBase(TemplateIconSolid, { name: 'TemplateSolid' });
export const TerminalOutline = createIconFromBase(TerminalIconOutline, { name: 'TerminalOutline' });
export const TerminalSolid = createIconFromBase(TerminalIconSolid, { name: 'TerminalSolid' });
export const ThumbDownOutline = createIconFromBase(ThumbDownIconOutline, {
	name: 'ThumbDownOutline',
});
export const ThumbDownSolid = createIconFromBase(ThumbDownIconSolid, { name: 'ThumbDownSolid' });
export const ThumbUpOutline = createIconFromBase(ThumbUpIconOutline, { name: 'ThumbUpOutline' });
export const ThumbUpSolid = createIconFromBase(ThumbUpIconSolid, { name: 'ThumbUpSolid' });
export const TicketOutline = createIconFromBase(TicketIconOutline, { name: 'TicketOutline' });
export const TicketSolid = createIconFromBase(TicketIconSolid, { name: 'TicketSolid' });
export const TranslateOutline = createIconFromBase(TranslateIconOutline, {
	name: 'TranslateOutline',
});
export const TranslateSolid = createIconFromBase(TranslateIconSolid, { name: 'TranslateSolid' });
export const TrashOutline = createIconFromBase(TrashIconOutline, { name: 'TrashOutline' });
export const TrashSolid = createIconFromBase(TrashIconSolid, { name: 'TrashSolid' });
export const TrendingDownOutline = createIconFromBase(TrendingDownIconOutline, {
	name: 'TrendingDownOutline',
});
export const TrendingDownSolid = createIconFromBase(TrendingDownIconSolid, {
	name: 'TrendingDownSolid',
});
export const TrendingUpOutline = createIconFromBase(TrendingUpIconOutline, {
	name: 'TrendingUpOutline',
});
export const TrendingUpSolid = createIconFromBase(TrendingUpIconSolid, { name: 'TrendingUpSolid' });
export const TruckOutline = createIconFromBase(TruckIconOutline, { name: 'TruckOutline' });
export const TruckSolid = createIconFromBase(TruckIconSolid, { name: 'TruckSolid' });
export const UploadOutline = createIconFromBase(UploadIconOutline, { name: 'UploadOutline' });
export const UploadSolid = createIconFromBase(UploadIconSolid, { name: 'UploadSolid' });
export const UserAddOutline = createIconFromBase(UserAddIconOutline, { name: 'UserAddOutline' });
export const UserAddSolid = createIconFromBase(UserAddIconSolid, { name: 'UserAddSolid' });
export const UserCircleOutline = createIconFromBase(UserCircleIconOutline, {
	name: 'UserCircleOutline',
});
export const UserCircleSolid = createIconFromBase(UserCircleIconSolid, { name: 'UserCircleSolid' });
export const UserGroupOutline = createIconFromBase(UserGroupIconOutline, {
	name: 'UserGroupOutline',
});
export const UserGroupSolid = createIconFromBase(UserGroupIconSolid, { name: 'UserGroupSolid' });
export const UserRemoveOutline = createIconFromBase(UserRemoveIconOutline, {
	name: 'UserRemoveOutline',
});
export const UserRemoveSolid = createIconFromBase(UserRemoveIconSolid, { name: 'UserRemoveSolid' });
export const UserOutline = createIconFromBase(UserIconOutline, { name: 'UserOutline' });
export const UserSolid = createIconFromBase(UserIconSolid, { name: 'UserSolid' });
export const UsersOutline = createIconFromBase(UsersIconOutline, { name: 'UsersOutline' });
export const UsersSolid = createIconFromBase(UsersIconSolid, { name: 'UsersSolid' });
export const VariableOutline = createIconFromBase(VariableIconOutline, { name: 'VariableOutline' });
export const VariableSolid = createIconFromBase(VariableIconSolid, { name: 'VariableSolid' });
export const VideoCameraOutline = createIconFromBase(VideoCameraIconOutline, {
	name: 'VideoCameraOutline',
});
export const VideoCameraSolid = createIconFromBase(VideoCameraIconSolid, {
	name: 'VideoCameraSolid',
});
export const ViewBoardsOutline = createIconFromBase(ViewBoardsIconOutline, {
	name: 'ViewBoardsOutline',
});
export const ViewBoardsSolid = createIconFromBase(ViewBoardsIconSolid, { name: 'ViewBoardsSolid' });
export const ViewGridAddOutline = createIconFromBase(ViewGridAddIconOutline, {
	name: 'ViewGridAddOutline',
});
export const ViewGridAddSolid = createIconFromBase(ViewGridAddIconSolid, {
	name: 'ViewGridAddSolid',
});
export const ViewGridOutline = createIconFromBase(ViewGridIconOutline, { name: 'ViewGridOutline' });
export const ViewGridSolid = createIconFromBase(ViewGridIconSolid, { name: 'ViewGridSolid' });
export const ViewListOutline = createIconFromBase(ViewListIconOutline, { name: 'ViewListOutline' });
export const ViewListSolid = createIconFromBase(ViewListIconSolid, { name: 'ViewListSolid' });
export const VolumeOffOutline = createIconFromBase(VolumeOffIconOutline, {
	name: 'VolumeOffOutline',
});
export const VolumeOffSolid = createIconFromBase(VolumeOffIconSolid, { name: 'VolumeOffSolid' });
export const VolumeUpOutline = createIconFromBase(VolumeUpIconOutline, { name: 'VolumeUpOutline' });
export const VolumeUpSolid = createIconFromBase(VolumeUpIconSolid, { name: 'VolumeUpSolid' });
export const WifiOutline = createIconFromBase(WifiIconOutline, { name: 'WifiOutline' });
export const WifiSolid = createIconFromBase(WifiIconSolid, { name: 'WifiSolid' });
export const XCircleOutline = createIconFromBase(XCircleIconOutline, { name: 'XCircleOutline' });
export const XCircleSolid = createIconFromBase(XCircleIconSolid, { name: 'XCircleSolid' });
export const XOutline = createIconFromBase(XIconOutline, { name: 'XOutline' });
export const XSolid = createIconFromBase(XIconSolid, { name: 'XSolid' });
export const ZoomInOutline = createIconFromBase(ZoomInIconOutline, { name: 'ZoomInOutline' });
export const ZoomInSolid = createIconFromBase(ZoomInIconSolid, { name: 'ZoomInSolid' });
export const ZoomOutOutline = createIconFromBase(ZoomOutIconOutline, { name: 'ZoomOutOutline' });
export const ZoomOutSolid = createIconFromBase(ZoomOutIconSolid, { name: 'ZoomOutSolid' });
